import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { useBackgroundTasksTracker } from "@hooks/background-tasks/use-background-tasks-tracker";
import { Grid } from "@mui-wrapper";
import { PROJECT_BACKGROUND_TASKS_REQUIRED_COLUMNS } from "@pages/project-details/project-bg-tasks/project-background-tasks-columns";
import { ProjectBackgroundTasksSkeleton } from "@pages/project-details/project-bg-tasks/project-background-tasks-skeleton";
import { ProjectBackgroundTasksTable } from "@pages/project-details/project-bg-tasks/project-background-tasks-table";
import { appStateSelector } from "@store/app/app-selector";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { sdbBackgroundTasksSelector } from "@store/sdb-background-tasks/sdb-background-tasks-selector";
import { useAppSelector } from "@store/store-helper";
import { TABS_CONTENT_PADDING } from "@utils/ui-utils";
import { filterVideoModeTasks } from "@pages/project-details/project-details";
import { NoCloudActivityDuoIcon } from "@flat-ui";

/**
 * Contains the backgrounds tasks of the project details
 */
export function ProjectBackgroundTasks(t0) {
  const $ = _c(17);
  const {
    projectId
  } = t0;
  const {
    isDevModeEnabled
  } = useAppSelector(appStateSelector);
  const taskType = isDevModeEnabled ? undefined : "VideoMode";
  const {
    isFetchingProjects
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let t1;
  if ($[0] !== projectId || $[1] !== taskType) {
    t1 = {
      projectId,
      taskType
    };
    $[0] = projectId;
    $[1] = taskType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isLoading
  } = useBackgroundTasksTracker(t1);
  const sdbBackgroundsTasks = useAppSelector(sdbBackgroundTasksSelector);
  let t2;
  if ($[3] !== isDevModeEnabled || $[4] !== sdbBackgroundsTasks) {
    t2 = filterVideoModeTasks(sdbBackgroundsTasks, isDevModeEnabled);
    $[3] = isDevModeEnabled;
    $[4] = sdbBackgroundsTasks;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const filteredSdbBackgroundTasks = t2;
  let content;
  const isLoadingBackgroundTasks = (isLoading || isFetchingProjects) && filteredSdbBackgroundTasks.length === 0;
  if (isLoadingBackgroundTasks) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ProjectBackgroundTasksSkeleton />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    content = t3;
  } else {
    if (filteredSdbBackgroundTasks.length === 0) {
      let t3;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <EmptyPage title="No recorded activity" subtitle="There is no recorded activity for this project." icon={NoCloudActivityDuoIcon} />;
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      content = t3;
    } else {
      let t3;
      if ($[8] !== filteredSdbBackgroundTasks || $[9] !== isLoadingBackgroundTasks || $[10] !== projectId || $[11] !== taskType) {
        t3 = <ProjectBackgroundTasksTable sdbBackgroundsTasks={filteredSdbBackgroundTasks} isLoading={isLoadingBackgroundTasks} requiredColumns={PROJECT_BACKGROUND_TASKS_REQUIRED_COLUMNS} projectId={projectId} taskType={taskType} />;
        $[8] = filteredSdbBackgroundTasks;
        $[9] = isLoadingBackgroundTasks;
        $[10] = projectId;
        $[11] = taskType;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      content = t3;
    }
  }
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: TABS_CONTENT_PADDING,
      width: "100%"
    };
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "100%"
    };
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== content) {
    t5 = <Grid container={true} sx={t3}><Grid sx={t4}>{content}</Grid></Grid>;
    $[15] = content;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}